<template>
    <UiModal title="Detalii profil" v-if="specialist" 
        :subtitle="specialist.full_name" :buttons="buttons"
        @close="$store.state.specialist.modals.description = false">

        <template slot="body">
            <div class="description-modal__title" v-if="currentPage == 0">
                Despre mine
            </div>
            <div class="description-modal__title" v-if="currentPage == 1">
                Servicii oferite
            </div>
            <div class="description-modal__title" v-if="currentPage == 2">
                Beneficii
            </div>
            <div class="description-modal__wrapper">
                <div class="description-modal__text" v-html="specialist.about" v-if="currentPage == 0"></div>
                <div class="description-modal__text" v-html="specialist.experience" v-if="currentPage == 1"></div>
                <div class="description-modal__text" v-html="specialist.education" v-if="currentPage == 2"></div>
            </div>
            <div class="description-modal__navigation">
                <div class="description-modal__arrow" @click="prevPage">
                    <i class="fas fa-arrow-left"></i>
                </div>
                <div class="description-modal__bullets">
                    <div class="description-modal__bullet"
                        :class="{'description-modal__bullet--active': currentPage == 0}"></div>
                    <div class="description-modal__bullet"
                        :class="{'description-modal__bullet--active': currentPage == 1}"></div>
                    <div class="description-modal__bullet"
                        :class="{'description-modal__bullet--active': currentPage == 2}"></div>
                </div>
                <div class="description-modal__arrow" @click="nextPage">
                    <i class="fas fa-arrow-right"></i>
                </div>
            </div>
        </template>
    </UiModal>
</template>

<script>
    import UiModal from "@/components/ui/Modal";
    import {
        mapGetters
    } from "vuex";
    import {
        mapActions
    } from "vuex";

    export default {
        components: {
            UiModal,
        },
        data: function () {
            return {
                buttons: [{
                    event: "close",
                    text: "Închide",
                    style: "",
                }],
                currentPage: 0
            };
        },
        methods: {
            ...mapActions({
                storeFeedback: 'specialist/storeFeedback'
            }),
            prevPage() {
                if (this.currentPage === 0) {
                    this.currentPage = 2;
                } else {
                    this.currentPage = Math.abs((this.currentPage-1)%3);
                }

                if (this.currentPage === 0) {
                    if (!(this.specialist.about)) {
                        this.prevPage();
                    }
                } else if (this.currentPage === 1) {
                    if (!(this.specialist.experience)) {
                        this.prevPage();
                    }
                } else if (this.currentPage === 2) {
                    if (!(this.specialist.education)) {
                        this.prevPage();
                    }
                }
            },
            nextPage() {
                this.currentPage = (this.currentPage + 1) % 3;

                if (this.currentPage === 0) {
                    if (!(this.specialist.about)) {
                        this.nextPage();
                    }
                } else if (this.currentPage === 1) {
                    if (!(this.specialist.experience)) {
                        this.nextPage();
                    }
                } else if (this.currentPage === 2) {
                    if (!(this.specialist.education)) {
                        this.nextPage();
                    }
                }
            }
        }, 
        computed: {
            ...mapGetters({
                specialist: "specialist/specialist",
            })
        }
    };
</script>

<style lang="scss" scoped>
    .description-modal {
        &__wrapper {
            height: 350px;
            max-height: 350px;
            overflow-y: auto;
        }

        &__title {
            font-size: 20px;
            font-family: 'DIN Pro', sans-serif;
            font-weight: 500;
            line-height: 20px;
            text-align: center;
            padding-bottom: 15px;
            border-bottom: 1px solid $color-light-gray;
            margin: 25px 0 10px;
        }

        &__text {
            font-family: 'DIN Pro', sans-serif;
            font-weight: 300;
            font-size: 16px;
            line-height: 1.8;
            margin-bottom: 25px;

            &::-webkit-scrollbar{
                display: block;
            }
        }

        &__navigation {
            margin-top: 15px;
            margin-bottom: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &__arrow {
            padding: 2px 12px;
            background-color: $color-primary;
            color: $color-card;
            cursor: pointer;
            font-size: 21px;
        }

        &__bullets {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 20px;
        }

        &__bullet {
            height: 10px;
            width: 10px;
            background-color: $color-light-gray;
            border-radius: 100%;

            &:not(:last-child) {
                margin-right: 10px;
            }

            &--active {
                background-color: $color-secondary;
            }
        }
    }
</style>